import type { FC } from 'react'
import type { SortOption } from 'services/Search/utils/sort'

import { Radio } from '@sok/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSortParam } from 'services/Search/hooks/use-sort-param'

interface SortOptionProps {
  sort: SortOption
}

export const SortRadio: FC<SortOptionProps> = ({ sort }) => {
  const { t } = useTranslation()
  const [activeSort, setSort] = useSortParam()

  const handleChange = useCallback(() => {
    setSort(sort[0], sort[1])
  }, [sort, setSort])

  const checked = !!activeSort && activeSort[0] === sort[0] && activeSort[1] === sort[1]
  const value = `${sort[0] || 'null'}_${sort[1] || 'null'}`

  return (
    <Radio
      checked={checked}
      data-test-id="search-sort-radio"
      name="search-sort-options"
      onChange={handleChange}
      value={value}
    >
      {t(sort[2])}
    </Radio>
  )
}
